import React, { useEffect, useState } from 'react';
import PerfilConstants from '../utils/PerfilConstants';
import PerfilController from '../controller/perfil.controller';
import { Card } from 'primereact/card';
import Container from '../../../../../vendors/components/Container';
import Field from '../../../../../vendors/components/Field';
import AnttButton from '../../../../../vendors/components/Button';
import { faCheck, faSearch, faUserPen } from '@fortawesome/free-solid-svg-icons';
import { Calendar } from 'primereact/calendar';
import PortalController from '../../../PublicPage/controller/portal.controller';
import If from '../../../../../vendors/components/If';

export default function Perfil() {
  const controller = new PerfilController();
  const tabs = PerfilConstants.TAB_LISTA;
  const [date, setDate] = useState(null);




  useEffect(() => {
    controller.init();
  }, []);

  const template = (row: any) => {
    return (
      <div className="perfil-evento-wrapper-minificada ">
        <div className="perfil-evento-tipo-minificada ">
          {tipoTemplate(row)}
        </div>
        <div className="perfil-evento-principal-list-minificada">
          <div><label><b>Número: </b> {row.numero}</label></div>
          <div><label><b>Período: </b> {row.periodoValidade}</label></div>
        </div>
        <div className="portal-evento-botao">
          <AnttButton
            faIcon={faSearch}
            className="p-button-rounded p-button-rounded-info mr-2"
            tooltip="Visualizar"
            onClick={() => click(row)}
            tooltipOptions={{ position: 'top' }}
          />
        </div>
      </div>
    );
  }
  const tipoTemplate = (row: any) => {
    if (row.tipoEvento === 'Audiência Pública') {
      return (
        <>
          <i className="pi pi-users" />
          <label>{row.tipoEvento}</label>
        </>
      );
    }
    if (row.tipoEvento === 'Tomada de Subsídios') {
      return (
        <>
          <i className="pi pi-inbox" />
          <label>{row.tipoEvento}</label>
        </>
      );
    }
    if (row.tipoEvento === 'Reunião Participativa') {
      return (
        <>
          <i className="pi pi-comments" />
          <label>{row.tipoEvento}</label>
        </>
      );
    }
    if (row.tipoEvento === 'Consulta Interna') {
      return (
        <>
          <i className="pi pi-lock" />
          <label>{row.tipoEvento}</label>
        </>
      );
    }
    return (
      <>
        <i className="pi pi-search" />
        <label>{row.tipoEvento}</label>
      </>
    );
  };
  const click = (row: any) => {
    if (!controller.isAuthenticated()) {
      controller.history.push('/public/evento/visualizar', { id: row.id });
    } else {
      controller.history.push('/evento/visualizar', { id: row.id });
    }
  }


  const header = () => {
    return (
      <>
        <div style={{ padding: '10px' }}>
          <h3 className="titulo-institucional">Bem vindo {controller.user.nome}</h3>
        </div>
      </>
    );
  }

  const RedirectPage = () => {
    return (
      window.open('https://www.youtube.com/watch?v=r66Gh4nsnRI)', '_blank')
    );
  };

  const footer = () => {
    return (
      <>
        <div className="flex">
          <AnttButton
            style={{ background: '#50C6E9', marginRight: '20px', color: 'white' }}
            faIcon={faCheck}
            faIconStyle={{ color: 'white', marginRight: '10px' }}
            faIconPos="left"
            onClick={() => RedirectPage()}
          >
            <label style={{ color: 'white' }}>Faça um tour pelo sistema</label>
          </AnttButton>
          <AnttButton
            style={{ background: '#50C6E9', marginRight: '20px', color: 'white' }}
            faIcon={faUserPen}
            faIconStyle={{ color: 'white', marginRight: '10px' }}
            faIconPos="left"
            onClick={() => controller.history.push('/perfil/atualizar')}
          >
            <label style={{ color: 'white' }}>Altere seus Dados</label>
          </AnttButton>
        </div>
      </>
    );
  }

  const dateTemplate = (date: any) => {
    let lista = controller.dates.filter((item1: Date) => item1.getFullYear() == date.year
      && item1.getMonth() == date.month
      && item1.getDate() == date.day)
    if (lista.length) {
      return (
        <span className='estilo_data_calendario'>{date.day}</span>
      );
    }

    return date.day;
  }

  return (
    <>
      <div className="perfil">
        <Container>
          <Field col={8}>
            <Card className=""
              footer={() => footer()}
              header={() => header()}>
              <p>
                Esse espaço permite que você gerencie suas contribuições e acompanhe eventos de interesse de forma prática. Utilize o
                menu para explorar suas atividades, gerenciar suas participações e manter-se atualizado.
              </p>
            </Card>
          </Field>
          <Field col={4}>
            <Card title="Eventos de seu interesse" >

              <div className='perfil-rolagem'>
                {controller.listaTemporaria.map((m: any, index: any) =>
                  <div key={`portal-evento-lista-${index}`}
                    onClick={() => click(m)}
                    className="portal-evento-lista">
                    {template(m)}
                  </div>
                )}
                <If condition={controller.listaTemporaria.length <= 0}>
                  <div className="text-center" style={{ margin: '20px 0' }}>
                    Nenhum registro encontrado
                  </div>
                </If>
              </div>



            </Card>
          </Field>
          <Field className="flex justify-content-center" col={8}>
            <div className="wrapper">
              <div className="wrapper-item">
                <div
                  className="p-card"
                  title='Contribuições Válidas para Analise'
                  onClick={() => controller.onClickMinhasContribuicoes('1')}>
                  <h1>{controller.value.contribuicoesAtivas}</h1>
                  <label>Válidas para Analise</label>
                </div>
                <div
                  className="p-card"
                  title='Contribuições Acolhidas ou Acolhidas Parcialmente'
                  onClick={() => controller.onClickMinhasContribuicoes('2')}>
                  <h1>{controller.value.eventosEncerrados}</h1>
                  <label>Acolhidas ou Acolhidas Parcialmente</label>
                </div>
                <div
                  className="p-card"
                  title='Contribuições Invalidadas e ou Não Acolhidas'
                  onClick={() => controller.onClickMinhasContribuicoes('3')}>
                  <h1>{controller.value.contribuicoesNegadas}</h1>
                  <label>Invalidadas e ou Não Acolhidas</label>
                </div>
              </div>
              <div className="wrapper-item">
                <div
                  className="p-card"
                  title='Contribuições Salvas e não Enviadas'
                  onClick={() => controller.onClickMinhasContribuicoes('6')}>
                  <h1>{controller.value.contribuicoesParcialmenteAtivas}</h1>
                  <label>Salvas e não Enviadas</label>
                </div>
                <div
                  className="p-card"
                  title='Contribuições Finalizadas em Eventos Abertos'
                  onClick={() => controller.onClickMinhasContribuicoes('7')}>
                  <h1>{controller.value.eventosAbertos}</h1>
                  <label>Finalizadas em Eventos Abertos</label>
                </div>
                <div
                  className="p-card"
                  title='Eventos de seu Interesse com Prazo próximo ao Encerramento'
                  onClick={() => controller.onClickMeusEventos('4')}>
                  <h1>{controller.value.prazosProximoAoFim}</h1>
                  <label>Próximo ao Encerramento</label>
                </div>
              </div>
            </div>
          </Field>
          <Field col={4}>
            <Card title="Calendário de Eventos">
              <div className="flex justify-content-center">
                <Calendar inline value={new Date(Date.now())} onChange={(e) => controller.selecionarEventosPelocalendario(e.value, [])} dateTemplate={dateTemplate} />
              </div>
            </Card>
          </Field>
        </Container>

      </div>
    </>
  );
}
